import React, { useState } from "react";
import DeleteDialog from "components/Dialogs/DeleteDialog";
import IconLoader from "components/IconLoader/IconLoader";
import { format } from "date-fns";
import showToast from "helpers/showToast";
import apiCall from "services/apiCall";
import { deleteSessionStudent } from "services/exam/session-service";
import { getExamApplicationReport } from "services/reporting-service";
import { downloadPdf } from "helpers/fileDownloadHelper";
import { tr } from "date-fns/esm/locale";

function EntryCertificate({ entryDocument, changeMultiplePageMode, setApplicationList }) {
  const [reportLoading, setReportLoading] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const downloadCertifivcate = () => {
    setReportLoading(true);
    apiCall({
      service: getExamApplicationReport,
      serviceParams: entryDocument,
      onSuccess: (res) => {
        setReportLoading(false);
        downloadPdf(res?.data?.list[0].report, res?.data?.list[0].name);
      },
      onError: () => {
        setReportLoading(false);
        showToast("PDF oluşturma işlemi sırasında hata oluştu.", { type: "error" });
      }
    });
  };

  const cancelRegistration = () => {
    apiCall({
      service: deleteSessionStudent,
      serviceParams: {
        identityNumber: entryDocument?.identityNumber,
        examId: entryDocument?.examId
      },
      onSuccess: () => {
        setApplicationList(
          (prev) => prev?.filter((application) => application?.id !== entryDocument?.id) || []
        );
        showToast("Sınav başvurunuz başarıyla silindi.", { type: "success" });
        openApplicationListPage();
        setShowDelete(false);
      },
      onError: () => {
        showToast("Sınav başvuru iptal etme işlemi sırasında hata oluştu", { type: "error" });
        setShowDelete(false);
      }
    });
  };

  const InfoCard = ({ title, content }) => {
    return (
      <div
        className="mt-4"
        style={{
          border: "solid #4584FF 1px",
          borderRadius: "0px 0px 10px 10px"
        }}
      >
        <center>
          <div style={{ background: "#F9F9F9", color: "#878787" }} className="py-4 lms-font-bold">
            {title}
          </div>
          <div className="lms-font-bold py-4">{content}</div>
        </center>
      </div>
    );
  };

  const openApplicationListPage = () => {
    const modeList = [
      { name: "registerForm", open: false },
      { name: "identityCheck", open: false },
      { name: "validEntry", open: false },
      { name: "applicationList", open: true }
    ];
    changeMultiplePageMode(modeList)();
  };

  return (
    <>
      <div className="container pt-16" style={{ position: "relative" }}>
        <div className="d-flex justify-content-between">
          <button onClick={openApplicationListPage} className="btn btn-primary">
            <IconLoader icon="mdiChevronLeft" size={1} />
          </button>
          <div className="d-flex">
            <button
              onClick={downloadCertifivcate}
              className={`btn btn-info ml-4 ${
                reportLoading ? "spinner spinner-white spinner-left" : ""
              }`}
              disabled={reportLoading}
            >
              <span className="mr-4">PDF Oluştur</span>
              <IconLoader icon="mdiPrinter" size={1} />
            </button>
            {entryDocument?.allowStudentDelete && (
              <button
                onClick={() => setShowDelete(true)}
                className={`btn btn-danger ml-4`}
                disabled={reportLoading}
              >
                <span className="mr-4">Başvuruyu Sil</span>
                <IconLoader icon="mdiDelete" size={1} />
              </button>
            )}
          </div>
        </div>

        <div className="mt-4">
          <center>
            <h1>Sınav Giriş Belgesi</h1>
            <span style={{ color: "#92929D" }}>
              Bu belgeyi sınava girerken yanınızda bulundurunuz ve sınav başlamadan önce salon{" "}
              <br />
              görevlilerine teslim ediniz.
            </span>
          </center>
        </div>
        <div className="row mt-4">
          <div className="col-lg-6 pr-2">
            <div className="row rounded py-4 px-10 mt-4" style={{ background: "#F9F9F9" }}>
              <div className="col-lg-6" style={{ color: "#878787" }}>
                TC Kimlik No:
              </div>
              <div className="col-lg-6 lms-font-bold">
                {entryDocument?.identityNumber?.slice(0, 7)}****
              </div>
            </div>
          </div>
          <div className="col-lg-6 pl-2">
            <div className="row rounded py-4 px-10 mt-4" style={{ background: "#F9F9F9" }}>
              <div className="col-lg-6" style={{ color: "#878787" }}>
                Adı Soyadı:
              </div>
              <div className="col-lg-6 lms-font-bold">{entryDocument?.studentNameSurname}</div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-lg-3">
            <InfoCard
              title="Sınav Tarihi"
              content={
                entryDocument?.examDate
                  ? format(new Date(entryDocument?.examDate), "dd/MM/yyyy cccc", { locale: tr })
                  : ""
              }
            />
          </div>
          <div className="col-lg-3">
            <InfoCard
              title="Sınav Saati"
              content={
                entryDocument?.examDate
                  ? format(new Date(entryDocument?.examDate), "HH:mm", { locale: tr })
                  : ""
              }
            />
          </div>
          <div className="col-lg-3">
            <InfoCard title="Salon No" content={entryDocument?.roomName || ""} />
          </div>
          <div className="col-lg-3">
            <InfoCard title="Sıra No" content={entryDocument?.deskNo} />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <InfoCard title="Sınav Yeri" content={entryDocument?.examSchoolName} />
          </div>
          <div className="col-lg-4">
            <InfoCard title="Sınav Adı" content={entryDocument?.examName} />
          </div>
          <div className="col-lg-4">
            <InfoCard title="Sınav Seviyesi" content={entryDocument?.examLevel} />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <InfoCard title="Sınav Yeri Adresi" content={entryDocument?.address} />
          </div>
          <div className="col-lg-6">
            <InfoCard
              title="Sisteme Giriş Adresi"
              content="https://app.myexamy.com/register-form"
            />
          </div>
        </div>
      </div>

      {showDelete && (
        <DeleteDialog
          show={showDelete}
          onHide={() => setShowDelete(false)}
          deleteAction={cancelRegistration}
          modalTitle="Sınav Başvurusunu Sil"
          modalMessage={`Sınav başvurusunu silmek istediğinize emin misiniz?`}
        />
      )}
    </>
  );
}

export default EntryCertificate;
